import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.typed.int8-array";
import "core-js/modules/es6.regexp.split";
import _classCallCheck from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/classCallCheck";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { ConnectionMessage, Deferred, MessageType, RawWebsocketMessage } from "../common/Exports";
var CRLF = "\r\n";
export var WebsocketMessageFormatter = function WebsocketMessageFormatter() {
  var _this = this;

  _classCallCheck(this, WebsocketMessageFormatter);

  this.toConnectionMessage = function (message) {
    var deferral = new Deferred();

    try {
      if (message.messageType === MessageType.Text) {
        var textMessage = message.textContent;
        var headers = {};
        var body = null;

        if (textMessage) {
          var headerBodySplit = textMessage.split("\r\n\r\n");

          if (headerBodySplit && headerBodySplit.length > 0) {
            headers = _this.parseHeaders(headerBodySplit[0]);

            if (headerBodySplit.length > 1) {
              body = headerBodySplit[1];
            }
          }
        }

        deferral.resolve(new ConnectionMessage(message.messageType, body, headers, message.id));
      } else if (message.messageType === MessageType.Binary) {
        var binaryMessage = message.binaryContent;
        var _headers = {};
        var _body = null;

        if (!binaryMessage || binaryMessage.byteLength < 2) {
          throw new Error("Invalid binary message format. Header length missing.");
        }

        var dataView = new DataView(binaryMessage);
        var headerLength = dataView.getInt16(0);

        if (binaryMessage.byteLength < headerLength + 2) {
          throw new Error("Invalid binary message format. Header content missing.");
        }

        var headersString = "";

        for (var i = 0; i < headerLength; i++) {
          headersString += String.fromCharCode(dataView.getInt8(i + 2));
        }

        _headers = _this.parseHeaders(headersString);

        if (binaryMessage.byteLength > headerLength + 2) {
          _body = binaryMessage.slice(2 + headerLength);
        }

        deferral.resolve(new ConnectionMessage(message.messageType, _body, _headers, message.id));
      }
    } catch (e) {
      deferral.reject("Error formatting the message. Error: ".concat(e));
    }

    return deferral.promise();
  };

  this.fromConnectionMessage = function (message) {
    var deferral = new Deferred();

    try {
      if (message.messageType === MessageType.Text) {
        var payload = "".concat(_this.makeHeaders(message)).concat(CRLF).concat(message.textBody ? message.textBody : "");
        deferral.resolve(new RawWebsocketMessage(MessageType.Text, payload, message.id));
      } else if (message.messageType === MessageType.Binary) {
        var headersString = _this.makeHeaders(message);

        var content = message.binaryBody;
        var headerInt8Array = new Int8Array(_this.stringToArrayBuffer(headersString));

        var _payload = new ArrayBuffer(2 + headerInt8Array.byteLength + (content ? content.byteLength : 0));

        var dataView = new DataView(_payload);
        dataView.setInt16(0, headerInt8Array.length);

        for (var i = 0; i < headerInt8Array.byteLength; i++) {
          dataView.setInt8(2 + i, headerInt8Array[i]);
        }

        if (content) {
          var bodyInt8Array = new Int8Array(content);

          for (var _i = 0; _i < bodyInt8Array.byteLength; _i++) {
            dataView.setInt8(2 + headerInt8Array.byteLength + _i, bodyInt8Array[_i]);
          }
        }

        deferral.resolve(new RawWebsocketMessage(MessageType.Binary, _payload, message.id));
      }
    } catch (e) {
      deferral.reject("Error formatting the message. ".concat(e));
    }

    return deferral.promise();
  };

  this.makeHeaders = function (message) {
    var headersString = "";

    if (message.headers) {
      for (var header in message.headers) {
        if (header) {
          headersString += "".concat(header, ": ").concat(message.headers[header]).concat(CRLF);
        }
      }
    }

    return headersString;
  };

  this.parseHeaders = function (headersString) {
    var headers = {};

    if (headersString) {
      var headerMatches = headersString.match(/[^\r\n]+/g);

      if (headers) {
        var _iterator = _createForOfIteratorHelper(headerMatches),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var header = _step.value;

            if (header) {
              var separatorIndex = header.indexOf(":");
              var headerName = separatorIndex > 0 ? header.substr(0, separatorIndex).trim().toLowerCase() : header;
              var headerValue = separatorIndex > 0 && header.length > separatorIndex + 1 ? header.substr(separatorIndex + 1).trim() : "";
              headers[headerName] = headerValue;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }

    return headers;
  };

  this.stringToArrayBuffer = function (str) {
    var buffer = new ArrayBuffer(str.length);
    var view = new DataView(buffer);

    for (var i = 0; i < str.length; i++) {
      view.setUint8(i, str.charCodeAt(i));
    }

    return buffer;
  };
};